module.exports = __webpack_public_path__ + "static/img/7.362b3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020.3.26/7.png
// module id = 3bAC
// module chunks = 1